// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_81PlU","foot_link":"index_foot_link_n-u8I","list":"index_list_te1uw","link":"index_link_yxbLu","copyright":"index_copyright_RPaxj"};